import { c as _c } from "react/compiler-runtime";
import AddTagSelector from 'modules/automation-rules/actions/components/add-tag-selector';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionTagEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import React from 'react';
interface ActionAddTagItemProps extends EditActionItemInterface<ActionTagEditInterface> {}
const ActionAddTagItem = t0 => {
  const $ = _c(13);
  const {
    actions,
    action,
    onDelete,
    setRules,
    errors,
    idx
  } = t0;
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action || $[4] !== actions || $[5] !== errors.automationActions || $[6] !== idx || $[7] !== setRules) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        renderActionLabel
      } = t3;
      return <AddTagSelector onOpen={onOpen} action={action} renderActionLabel={renderActionLabel} onChange={data_0 => setRules(prev => ({
        ...prev,
        actions: actions.map((el, i) => {
          if (idx === i) {
            return {
              ...el,
              tag: {
                id: data_0
              }
            };
          } else {
            return el;
          }
        })
      }))} error={errors.automationActions[action.id]?.tag?.join("")} data={data} />;
    };
    $[3] = action;
    $[4] = actions;
    $[5] = errors.automationActions;
    $[6] = idx;
    $[7] = setRules;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== action.type || $[10] !== t1 || $[11] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[9] = action.type;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default ActionAddTagItem;